import { IconChevronDown, IconChevronRight } from '@tabler/icons-react'
import { GroupBase, GroupHeadingProps } from 'react-select'

import { SizeOptions } from '../../../../types/types'
import { AstraIcon } from '../../../AstraIcon/AstraIcon'
import { AstraParagraph } from '../../../Typography/AstraParagraph/AstraParagraph'
import { AstraButton } from '../../AstraButton/AstraButton'
import { AstraCheckbox, AstraCheckboxProps } from '../../AstraCheckbox/AstraCheckbox'
import { SelectOption } from '../../AstraSelect'
import { typographySizeStyles } from '../utils/utils'

export type AstraMultiSelectGroupHeadingProps<T> = GroupHeadingProps<SelectOption<T>, true, GroupBase<SelectOption<T>>> &
    Pick<AstraCheckboxProps, 'checked'> & {
        size: SizeOptions
        onGroupExpandClick: (group: GroupBase<SelectOption<T>>, isExpand: boolean) => void
        onGroupClick: (group: GroupBase<SelectOption<T>>, state: boolean) => void
        isExpanded?: boolean
    }

export const AstraMultiSelectGroupHeading = <T,>({
    data,
    size,
    checked,
    onGroupClick,
    onGroupExpandClick,
    isExpanded = true,
    ...props
}: AstraMultiSelectGroupHeadingProps<T>) => (
    <div className="flex cursor-pointer items-center gap-1 px-2 py-1 hover:bg-surface-muted" onClick={() => onGroupClick(data, checked === false)} {...props}>
        <AstraButton
            size={size}
            variant="ghost"
            icon={isExpanded ? <AstraIcon icon={IconChevronDown} size={size} /> : <AstraIcon icon={IconChevronRight} size={size} />}
            onClick={e => {
                e.stopPropagation()
                onGroupExpandClick(data, !isExpanded)
            }}
        />
        <div className="flex w-full items-center gap-1">
            <AstraCheckbox size={size} checked={checked} />
            <AstraParagraph variant={typographySizeStyles[size]}>{data.label}</AstraParagraph>
        </div>
    </div>
)
